import React from "react";
import {Image} from 'react-bootstrap';

import "./Footer.css";

import QR from "../../asset/images/QR.png";

class Footer extends React.Component {
  render() {
    return (
      <div className="footer">
        <div className="footer_button">
          <div className="footer_module">
            <div className="footer_title">快速入口</div>
            <div className="footer_module_buts">
              <ul>
                <li>产品与服务</li>
                <li>新闻资讯</li>
                <li>成功案例</li>
                <li>关于我们</li>
              </ul>
            </div>
          </div>
          <div className="footer_module">
            <div className="footer_title">业务覆盖</div>
            <div className="footer_module_buts">
              <ul>
                <li>空压板块</li>
                <li>空调板块</li>
                <li>热回收板块</li>
                <li>查看更多</li>
              </ul>
            </div>
          </div>
          <div className="footer_module">
            <div className="footer_title">关于我们</div>
            <div className="footer_module_buts">
              <ul>
                <li>公司简介</li>
                <li>发展历程</li>
                <li>核心团队</li>
                <li>加入我们</li>
              </ul>
            </div>
          </div>
          <div className="footer_module">
            <div className="footer_title">联系我们</div>
            <div className="footer_module_buts">
              <ul>
                <li>TEL：010-67658450</li>
                <li>Emall：service@hzby.tech</li>
                <li>TIME：09:00 - 18:00</li>
                <li>ADD：北京市朝阳区光华路15号亿利生态广场1712室</li>
              </ul>
            </div>
          </div>
          <div className="weixin">
            <div className="weixin_titile">
              关注涵智博雅
            </div>
            <Image className="weixin_QR" src={QR} />
          </div>
        </div>
        <div className="footer_message">
          <div className="footer_word">
            <div>涵智博雅能源科技有限公司©2017</div>
            <div>京ICP备19045702号-1</div>
            <div className="address">地址：北京市朝阳区光华路15号亿利生态广场1712室</div>
          </div>
        </div>
      </div>
    )
  }
}

export default Footer
